import type { ListBuilderMobileCardConfig } from '../../types';
import { SHOP_MAX_META_PAIRS } from '../client-shop/shared';

/**
 * Required fields for quote_shop_default list
 */
export const QUOTE_SHOP_DEFAULT_REQUIRED_FIELDS = [
	'_id',
	'primaryImageUrl',
	'category',
	'description',
	'externalId',
	'externalId2',
	'isShortDate',
	'isHazmat',
	'isRefrigerated',
	'manufacturer',
	'minimumPrice',
	'price',
	'quantityOnHand',
	'quantityReserved',
	'quantityOnOrder',
	'sizeCount',
	'soonestExpirationDate',
	'subcategory',
	'unitOfMeasure',
	'addressSoldUnitsMtd',
	'addressSoldUnitsLastMonth',
	'addressSoldUnitsTwoMonthsAgo',
	'lastInvoiceId',
	'addressLastPrice',
	'lastInvoiceExternalId',
	'lastInvoiceDate',
];

/**
 * Required fields for quote_shop secondary lists
 */
export const QUOTE_SHOP_STANDARD_REQUIRED_FIELDS = [
	'client_shop._id',
	'client_shop.primaryImageUrl',
	'addressSoldUnitsMtd',
	'addressSoldUnitsLastMonth',
	'addressSoldUnitsTwoMonthsAgo',
	'lastInvoiceId',
	'addressLastPrice',
	'lastInvoiceExternalId',
	'lastInvoiceDate',
	'item._id',
	'item.category',
	'item.description',
	'item.externalId',
	'item.isShortDate',
	'item.isHazmat',
	'item.isRefrigerated',
	'item.manufacturer',
	'item.minimumPrice',
	'item.price',
	'item.quantityOnHand',
	'item.quantityReserved',
	'item.quantityOnOrder',
	'item.sizeCount',
	'item.soonestExpirationDate',
	'item.subcategory',
	'item.unitOfMeasure',
];

/**
 * Standard mobile card config for quote shop lists — mirrors the client
 * shop's zones layout (SHOP_MOBILE_CARD_CONFIG): name/manufacturer title
 * block, Target price as the hero metric, every other configured column as
 * inline meta chips. The quote keeps its separate quantity + price input
 * columns as the full-width controls at the card bottom.
 */
export const QUOTE_SHOP_MOBILE_CARD_CONFIG: ListBuilderMobileCardConfig = {
	cardLayout: 'zones',
	primaryFields: ['item_details'],
	heroField: 'column_1751545591402.field_1751545620039',
	controlsColumns: ['quantity', 'price'],
	hiddenFields: ['image'],
	maxMetaPairs: SHOP_MAX_META_PAIRS,
};
